export const createDiv = (className) => {
  const div = document.createElement(`div`);
  div.className = className;

  return div;
};
